/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { ParsedToken } from 'firebase/auth';
import AppConfig from '../../AppConfig';
import UserService, { CustomClaims } from '../usuarios/UsuarioController';

export default class AppContexto
{
    public appConfig:any = AppConfig;
    public usuario: UserService;
    public permissao: CustomClaims | null;

    public constructor()
    {
        this.usuario = new UserService();
        
        this.usuario.getPermissao()
        .then(permissao => this.permissao = permissao || null)
        .catch(error => { console.error('Erro ao obter reivindicações personalizadas:', error) }); 
    }
}